

import {useState, useEffect, useRef } from 'react';
import {Link, useSearchParams, useLocation} from 'react-router-dom'

import Emblem from '../Emblem/emblem.component';
import BreadCrumb from '../BreadCrumb/breadcrumb.component';
import FiltersTags from '../FiltersTags/filterstags.component';
import FiltersPanel from '../FiltersPanel/filterspanel.component';

import ShortResource from '../ShortResource/shortresource.component';

import ReactPaginate from 'react-paginate';

import { polishPlurals } from 'polish-plurals';

import './resources.style.css'

import { useTranslation } from "react-i18next";
import "../../translations/i18n";
import Loader from '../Loader/loader.component';

const Resources = ({apiUrl, globalSearchString, globalSearchType, onFilteredResourcesChange, onSearchUrlChange, onClearGlobalSearchString, onClearGlobalSearchType}) => {

    const [searchParams, setSearchParams] = useSearchParams(new URLSearchParams(useLocation().search))
    const [filtersReady, setFiltersReady] = useState(false);
    const [apiSearchString, setApiSearchString] = useState('');
    const [filterId2Name, setFilterId2Name] = useState({})
    //const [appliedFilters, setAppliedFilters] = useState(new URLSearchParams(useLocation().search));
    const [appliedFilters, setAppliedFilters] = useState({});
    const [resources, setResources] = useState([]);
    const [filters, setFilters] = useState([]);
  
    const [itemsPerPage, setItemsPerPage] = useState(5);
  
    const [loading, setLoading] = useState(true);

    const [currentResources, setCurrentResources] = useState(null);
    const [pageCount, setPageCount] = useState(0);
    const [resourceOffset, setResourceOffset] = useState(0);
    const [currentPage, setCurrentPage] = useState(0);
    const [resourceCount, setResourceCount] = useState(0);
    //console.log(window.location.href);
    
    const pagination_ref = useRef(null);

  const {t} = useTranslation();
    
    useEffect(()=>{
      const endOffset = resourceOffset + itemsPerPage;
      setCurrentResources(resources.slice(resourceOffset, endOffset));
      setPageCount(Math.ceil(resources.length / itemsPerPage));
    }, [resourceOffset, itemsPerPage, resources]);
  
    // useEffect(()=>{
    //   const newApiSearchString = (' ' + apiSearchString).slice(1);
    //   setApiSearchString(newApiSearchString);
    // })
  
    useEffect(()=>{
      fetch(apiUrl+'Filters/')
      .then(response=> response.json())
      .then((filters) => {
        setFilters(filters);
        let id2name = {}
        filters.forEach(filter=>{
          let key = filter.Key;
          id2name[filter.Key] = {}
          filter.Values.forEach((value)=>{
            id2name[key][value.Id] = value.Name;
           })
         setFilterId2Name(id2name);
         })
      }
      );
    },[apiUrl]
    )
  
  
    useEffect(()=>{
      if (filtersReady)
        return
      let newAppliedFilters = {};
      for (let params of searchParams.entries()) {
        let key = params[0];
        let val = params[1];
        if (!(key in newAppliedFilters))
          newAppliedFilters[key]=[];
        if (! newAppliedFilters[key].includes(val))
          newAppliedFilters[key].push(val);
      };
      setAppliedFilters(newAppliedFilters);
      setFiltersReady(true);
      
  
  
    },[searchParams]);
  
  
    useEffect(()=>{
      var newApiSearchString = '';
      for (const [key, value] of Object.entries(appliedFilters)) {
        const new_val = value.map(x=>encodeURIComponent(x))
        newApiSearchString += key+'='+new_val.join(',')+';';
      }
      //console.log(JSON.stringify(newApiSearchString));
      setApiSearchString(newApiSearchString);
      onSearchUrlChange(window.location.href);
    },
    [appliedFilters, searchParams])
  
    useEffect(()=>{
  
      //console.log("res type string")
      var toAdd = []
      if (globalSearchType)
        toAdd.push({data_id: globalSearchType, data_category: 'type'});
      //   filterAdd(globalSearchType, 'type');
      
      if (globalSearchString)
        toAdd.push({data_id: globalSearchString, data_category: 'q'});
  
      if (!filtersReady) {
        for (let params of searchParams.entries()) {
          let key = params[0];
          let val = params[1];
          if (key!=='q')
            val = parseInt(val);
          toAdd.push({data_id: val, data_category: key});
        };
      }
      //console.log(toAdd);
      filterAddMany(toAdd);
      setFiltersReady(true);
    },[globalSearchString, globalSearchType, searchParams])
    
    useEffect(
      ()=> {
        //console.log('Try api call');
        let force=window.location.href.endsWith('/search/') || window.location.href.endsWith('/search');
        if (filtersReady || force) // ładujemy stronę po tym jak się sparsuje url, mamy wtedy appliedFilters i apisearchstring wtedy filtersReady jest true
        {
        const url=apiUrl+'ShortResources/?'+  apiSearchString;
        
        setLoading(true);
        //console.log('API called: '+url)
        fetch(url)
        .then(response=> response.json())
        .then((resources) => {
          setResources(resources);
          onFilteredResourcesChange(resources);
          setLoading(false);
        }).catch((error)=>{
          setResources([])
          onFilteredResourcesChange([]);
          setLoading(false);
        });
       }
      },[apiSearchString, apiUrl]);
  
  
  
  
    const filterAddMany = (arr) => {
      let newAppliedFilters = Object.assign({},appliedFilters);
      for (const e of arr) {
        if (e.data_category === "") continue;
        if (!(e.data_category in newAppliedFilters)) {
          newAppliedFilters[e.data_category] = [];
        }
        if (! newAppliedFilters[e.data_category].includes(e.data_id)) {
          //jesli jest to q, to chcemy zeby bylo tylko jedno i zastepujemy
          if (e.data_category==='q')
            newAppliedFilters[e.data_category][0] = e.data_id;
          else
            newAppliedFilters[e.data_category].push(e.data_id);
        }
      }
      setSearchParams(newAppliedFilters);
      setAppliedFilters(newAppliedFilters);
      
    }
    
    const filterAdd = (data_id, data_category) => {
      //console.log("add", data_category, data_id);
      let newAppliedFilters = Object.assign({},appliedFilters);
      if (!(data_category in newAppliedFilters)) {
        newAppliedFilters[data_category] = [];
      }
      if (! newAppliedFilters[data_category].includes(data_id)) {
        //jesli jest to q, to chcemy zeby bylo tylko jedno i zastepujemy
        if (data_category==='q')
          newAppliedFilters[data_category][0] = data_id;
        else
        { 
          const new_data_id = parseInt(data_id)
          if (! newAppliedFilters[data_category].includes(new_data_id))
            newAppliedFilters[data_category].push(new_data_id);
        }
        setSearchParams(newAppliedFilters);
        setAppliedFilters(newAppliedFilters);
        
      }
    }
  
  
    //FIXME specjalne traktowanie filtra z searchbara type ktory sie nie kasuje
    const filterRemove = (data_id, data_category) => {
      //console.log(typeof(data_id), data_id);
      //console.log(data_category);
      //console.log(globalSearchType)
      let newAppliedFilters = Object.assign({},appliedFilters);
      if ((data_category==='q') && (data_category in newAppliedFilters)) {
        delete newAppliedFilters['q'];
        setSearchParams(newAppliedFilters);
        setAppliedFilters(newAppliedFilters);
  
        onClearGlobalSearchString();
        setResourceOffset(0);
        setCurrentPage(0);
        return;
      }
      const new_data_id = parseInt(data_id);
      if ((data_category==='type') && (data_category in newAppliedFilters) && (new_data_id==globalSearchType))
      {
        //console.log("tu")
        var index = newAppliedFilters[data_category].indexOf(new_data_id);
        newAppliedFilters[data_category].splice(index,1);
        if (newAppliedFilters[data_category].length === 0)
          delete newAppliedFilters[data_category];
          setSearchParams(newAppliedFilters);
          setAppliedFilters(newAppliedFilters);
          onClearGlobalSearchType();
          setResourceOffset(0);
          setCurrentPage(0);
          return;
      }
      if ((data_category in newAppliedFilters) && (newAppliedFilters[data_category].includes(new_data_id))) {
        var index = newAppliedFilters[data_category].indexOf(new_data_id);
        newAppliedFilters[data_category].splice(index,1);
        if (newAppliedFilters[data_category].length === 0)
          delete newAppliedFilters[data_category];
        // if ((data_category==='type') && (data_id===globalSearchType))
        //   onClearGlobalSearchType();
        //console.log(newAppliedFilters);
        setSearchParams(newAppliedFilters);
        setAppliedFilters(newAppliedFilters);
        setResourceOffset(0);
        setCurrentPage(0);
      }
    }
  
    const onChangeFilters = event => {
      const data_id = event.target.getAttribute('data-id');
      const data_category = event.target.getAttribute('data-category');
      if (event.target.checked) {
        filterAdd(data_id, data_category);
        setResourceOffset(0);
        setCurrentPage(0);
      }
      else {
        filterRemove(data_id, data_category);
        setResourceOffset(0);
        setCurrentPage(0);
      }
      
      pagination_ref.forcePage = 0;
      

    }
  
    const onRemoveAllFilters = event => {
      if (globalSearchString !== '') 
        onClearGlobalSearchString();
      if (globalSearchType !== '')
        onClearGlobalSearchType();
      let newAppliedFilters = {};
  
      setSearchParams(newAppliedFilters);
      setAppliedFilters(newAppliedFilters);
      setResourceOffset(0);
      setCurrentPage(0);
    }
  
    const onTagRemove = event => {
      const data_id = event.target.getAttribute('data-id');
      const data_category = event.target.getAttribute('data-category');
      filterRemove(data_id, data_category);
    }
  
  
    const handlePageClick = event => {

      const newOffset = (event.selected * itemsPerPage) % resources.length;

      //console.log(
      //   `User requested page number ${event.selected}, which is offset ${newOffset}`
      // );
      setResourceOffset(newOffset);
      setCurrentPage(event.selected);
      //setResourceOffset(event.selected);
      //setResourceOffset(0);
    }
  
  
    return (
      <>
  
  <BreadCrumb paths={
              [
                  {
                    Name: t('breadcrumb.start.name'),
                    Url: t('breadcrumb.start.url')
                  },
                  {
                    Name: t('breadcrumb.infrastructure.name'),
                    Url: t('breadcrumb.infrastructure.url')
                  },
                  {
                    Name:t('breadcrumb.catalogue.name'),
                    Url:t('breadcrumb.catalogue.url'),
                  },
                  {
                    Name:t('breadcrumb.search.name'),
                    Url: ''
                  },
              ]
              }
          />
  
      <div className="resources-header">
        <h1>{t('resources.catalogue')}</h1>
        
        <div className="results_counter">
          <div>
          <strong>{t('resources.search_result')}</strong> ({resources.length} {polishPlurals(t('resources.wynik'),t('resources.wyniki'),t('resources.wynikow'),resources.length)})
          </div>
          { loading && 
              <Loader></Loader>
          }
        </div>
  
      </div>



      <div className="resources-wrapper">
        <div className="resources-filters">
          <FiltersPanel filters={filters} appliedFilters={appliedFilters} onChangeFilters={onChangeFilters} onRemoveAllFilters={onRemoveAllFilters}/>
        </div>




        <div className="resources-list">
          <FiltersTags filterId2Name={filterId2Name}  appliedFilters={appliedFilters} onTagRemove={onTagRemove}/>

          { pageCount > 1 &&
            <ReactPaginate
              className="resource-pagination resource-pagination-top"
              breakLabel="..."
              nextLabel={t('resources.next_page')}
              onPageChange={handlePageClick}
              pageRangeDisplayed={5}
              pageCount={pageCount}
              previousLabel={t('resources.previous_page')}
              renderOnZeroPageCount={null}
              forcePage={currentPage}
          />}

 

          { currentResources && currentResources.map( (resource, index) => {
            return (
              <ShortResource resource={resource} index={index} ></ShortResource>
            )
          })}

          { pageCount > 1 &&
            <ReactPaginate
              className="resource-pagination resource-pagination-bottom"
              breakLabel="..."
              nextLabel={t('resources.next_page')}
              onPageChange={handlePageClick}
              pageRangeDisplayed={5}
              pageCount={pageCount}
              previousLabel={t('resources.previous_page')}
              renderOnZeroPageCount={null}
              forcePage={currentPage}
          />}
        </div>
      </div>
      </>
    )
  }


export default Resources